import React from 'react';

import { StarSolidIcon } from '../../../shared/icons/icons';
import { RatingSummary } from '../star-bar-rating';

import './star-bar-rating-item.scss';

interface StarBarRatingItemProps {
  onBarClick?: (ratingSummary: RatingSummary) => void;
  ratingSummary: RatingSummary;
  totalCount: number;
}

function StarBarRatingItem(props: StarBarRatingItemProps) {
  const { onBarClick, ratingSummary, totalCount } = props;

  const ratingCount = ratingSummary.count ? ratingSummary.count : 0;
  const fillPercentage = (ratingCount / totalCount) * 100;

  function handleClick() {
    if (typeof onBarClick === 'function') {
      onBarClick(ratingSummary);
    }
  }

  return (
    <div styleName="rating">
      <span styleName="rating-value">{ratingSummary?.rating}</span>
      <StarSolidIcon styleName="rating-star" />
      <div
        onClick={handleClick}
        onKeyDown={handleClick}
        role="button"
        styleName="rating-bar"
        tabIndex={0}
      >
        <span
          style={{
            width: `${fillPercentage}%`
          }}
          styleName="rating-bar-fill"
        />
      </div>
      <span styleName="rating-count">{ratingCount}</span>
    </div>
  );
}

export default StarBarRatingItem;
